/* eslint-disable */
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: pnpm run autoexport.
//

export { default as pdfium } from "./pdfium/pdfium.wasm"
